export class DomElementStyle {
    private element: HTMLElement;
    private style: CSSStyleDeclaration;

    constructor(element: HTMLElement) {
        this.element = element;
        this.style = getComputedStyle(element);
    }

    public width(): number {
        return parseFloat(this.style.width || '0');
    }

    public height(): number {
        return parseFloat(this.style.height || '0');
    }

    public maxWidth(): number {
        return parseFloat(this.style.maxWidth || '0');
    }

    public maxHeight(): number {
        return parseFloat(this.style.maxHeight || '0');
    }

    public padding(): Dimensions {
        return {
            left: parseFloat(this.style.paddingLeft || '0'),
            right: parseFloat(this.style.paddingRight || '0'),
            top: parseFloat(this.style.paddingTop || '0'),
            bottom: parseFloat(this.style.paddingBottom || '0')
        }
    }

    public margin(): Dimensions {
        return {
            left: parseFloat(this.style.marginLeft || '0'),
            right: parseFloat(this.style.marginRight || '0'),
            top: parseFloat(this.style.marginTop || '0'),
            bottom: parseFloat(this.style.marginBottom || '0')
        }
    }

    public border(): Dimensions {
        return {
            left: parseFloat(this.style.borderLeftWidth || '0'),
            right: parseFloat(this.style.borderRightWidth || '0'),
            top: parseFloat(this.style.borderTopWidth || '0'),
            bottom: parseFloat(this.style.borderBottomWidth || '0')
        }
    }
}

interface Dimensions {
    left: number;
    right: number;
    top: number;
    bottom: number;
}
